import { useTheme } from '@/components/theme/theme-provider';
import { Toaster as Sonner } from 'sonner';

export function Toaster() {
    const { theme } = useTheme();

    return (
        <Sonner
            theme={theme === 'system' ? 'system' : theme}
            className="toaster group"
            closeButton
            toastOptions={{
                classNames: {
                    toast: 'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
                    description: 'group-[.toast]:text-muted-foreground text-sm',
                    actionButton:
                        'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
                    cancelButton:
                        'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
                    closeButton:
                        'group-[.toast]:bg-background group-[.toast]:border-border group-[.toast]:text-foreground',
                },
            }}
        />
    );
}
